import { render, staticRenderFns } from "./JxcOrderList.vue?vue&type=template&id=461a526e&"
import script from "./JxcOrderList.vue?vue&type=script&lang=js&"
export * from "./JxcOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports